import { OMS_WIDTH } from '@src/styles/dimensions';
import {
  AppwideDrawerContentType,
  MixpanelEvent,
  MixpanelSourceContext,
  MixpanelSourceProvider,
  Text,
  useAppwideDrawerContext,
  useMixpanel,
  type CustomerTrade,
} from '@talos/kyoko';
import { useCallback, useContext } from 'react';
import { BookAndModifyTradeDrawer } from './BookAndModifyTradeDrawer';
import { customerTradeToForm, getInitialCustomerTradeForm } from './useCustomerTradeForm';

export function useCustomerTradeDrawer() {
  const { openDrawer, closeDrawer } = useAppwideDrawerContext();
  const mixpanel = useMixpanel();
  const mixpanelSource = useContext(MixpanelSourceContext);

  const openCustomerTradeDrawer = useCallback(
    (customerTrade?: CustomerTrade) => {
      const isEdit = customerTrade != null;
      const initialForm = isEdit ? customerTradeToForm(customerTrade) : getInitialCustomerTradeForm();
      const source = mixpanelSource;
      mixpanel.track(isEdit ? MixpanelEvent.OpenModifyCustomerTrade : MixpanelEvent.OpenNewCustomerTrade);

      openDrawer({
        type: AppwideDrawerContentType.EntityAdmin,
        title: 'Customer Trade',
        width: OMS_WIDTH,
        drawerHeaderDesign: 'flex',
        flexHeaderTitle: () => (
          <Text data-testid="customer-trade-drawer-title" fontWeight="500">
            Customer Trade
          </Text>
        ),
        renderContent: () => (
          <MixpanelSourceProvider value={source}>
            <BookAndModifyTradeDrawer initialForm={initialForm} onClose={closeDrawer} />
          </MixpanelSourceProvider>
        ),
      });
    },
    [closeDrawer, mixpanel, mixpanelSource, openDrawer]
  );

  return {
    openCustomerTradeDrawer,
    closeCustomerTradeDrawer: closeDrawer,
  };
}
